import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Tabs,
  Tab,
  Box,
  useMediaQuery,
  Snackbar,
  IconButton,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { Close } from "@material-ui/icons";
import useLocalStorage from "../hooks/useLocalStorage";

import Display from "./Display";
import UserInformation from "./UserInformation";
import MoreInfo from "./MoreInfo";
import Heirlooms from "./Heirlooms";
import { COLORS, BATTLEPASSES_ORDERED } from "../types";
import Confetti from "react-confetti";
import { clone } from "lodash";
// import utils from "../utils";

const useStyles = makeStyles((theme) => ({
  mainTabs: {
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
  },
  apexRed: {
    color: COLORS.RED,
  },
  tabActive: {
    backgroundColor: "#ffffff11",
  },
  mainTab: {
    fontSize: "0.875rem",
    [theme.breakpoints.down("xs")]: {
      fontSize: "0.75rem",
    },
  },
}));

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </Typography>
  );
};

/*
  970x90 (L)
  --------1020
  728x90 (M)
  --------775
  320x50 (S)
  --------370
  300x50 (XS)
*/

export default () => {
  const classes = useStyles();
  const mqL = useMediaQuery("(min-width: 1021px)");
  const mqM = useMediaQuery("(min-width: 776px) and (max-width: 1020px)");
  const mqS = useMediaQuery("(min-width: 371px) and (max-width: 775px)");
  const mqXS = useMediaQuery("(max-width: 370px)");

  const [adsLoadedL, setAdsLoadedL] = useState(false);
  const [adsLoadedM, setAdsLoadedM] = useState(false);
  const [adsLoadedS, setAdsLoadedS] = useState(false);
  const [adsLoadedXS, setAdsLoadedXS] = useState(false);

  const mqBelow530 = useMediaQuery("(max-width: 530px)");
  const mqBelow440 = useMediaQuery("(max-width: 440px)");
  const mqBelow370 = useMediaQuery("(max-width: 370px)");

  // scaffolding utils: localstorage migration
  // utils();

  // persistant state
  const [heirloomRecord, setHeirloomRecord] = useLocalStorage(
    "heirloomRecord",
    null
  );
  // ephemeral state
  const [showConfetti, setShowConfetti] = useState(false);

  const initialState = {
    accountLevel: null, // input account level (max 500)
    accountPacks: null, // calculated number of Apex Packs based on accountLevel
    purchasedPacks: null, // input number of Apex Packs directly purchased
    // calculated number of Apex Packs earned by the player each season
    seasonalPacks: [
      null, // 0
      null, // 1
      null, // 2
      null, // 3
      null, // 4
      null, // 5
      null, // 6
      null, // 7
      null, // 8
      null, // 9
      null, // 10
      null, // 11
      null, // 12
      null, // 13
      // SEASON+
    ],
    // calculated number of Apex Packs resulting from collecting treasure packs
    seasonalQuestPacks: [
      null, // 0  N/A
      null, // 1  N/A
      null, // 2  N/A
      null, // 3  N/A
      null, // 4  N/A
      null, // 5  seasonalQuestPacks
      null, // 6  season6QuestPacks
      null, // 7  season7QuestPacks
      null, // 8  season8QuestPacks
      null, // 9  season9QuestPacks
      null, // 10  season10QuestPacks
      null, // 11  season11QuestPacks
      null, // 12  season12QuestPacks
      null, // 13
      // SEASON+
    ],
    // input number of treasure packs picked up as in-game loot (1/day)
    seasonalTreasurePacks: [
      null, // 0  N/A
      null, // 1  N/A
      null, // 2  N/A
      null, // 3  N/A
      null, // 4  N/A
      null, // 5  treasurePacks
      null, // 6  treasurePacksS6
      null, // 7  treasurePacksS7
      null, // 8  treasurePacksS8
      null, // 9  treasurePacksS9
      null, // 10 treasurePacksS10
      null, // 11 treasurePacksS11
      null, // 12 treasurePacksS12
      null, // 13
      // SEASON+
    ],
    miscPacks: null, // bugs + misc packs
    twitchPrime: false, // +5 packs for linking Twitch Prime
    // represents if user has purchased seasonal premium battlepass
    seasonalBattlePasses: [
      null, // 0 N/A
      false, // 1
      false, // 2
      false, // 3
      false, // 4
      false, // 5
      false, // 6
      false, // 7
      false, // 8
      false, // 9
      false, // 10
      false, // 11
      false, // 12
      false, // 13
      // SEASON+
    ],
    // input number of the higheset seasonal level achieved (max 110)
    seasonalAchievedLevel: [
      null, // 0 N/A
      null, // 1
      null, // 2
      null, // 3
      null, // 4
      null, // 5
      null, // 6
      null, // 7
      null, // 8
      null, // 9
      null, // 10
      null, // 11
      null, // 12
      null, // 13
      // SEASON+
    ],
    // null: 0 LTMs that season
    // [null[..., null]]: length = number of LTMs this season
    seasonalLTMs: [
      null, // 0 N/A
      null, // 1 N/A
      null, // 2 N/A
      null, // 3 N/A
      null, // 4 N/A
      null, // 5 N/A
      null, // 6 N/A
      null, // 7 N/A
      [null], // 8
      [null], // 9
      [null, null], // 10
      null, // 11 N/A
      [null], // 12
      null, // 13
      // SEASON+
    ],
  };

  /**
   * Update: used to update the main app state
   * @param {String|Array} valueToUpdate Either string for top-level, or ["string", index] for second level values
   * @param {any} value The value to be updated
   */
  const update = (valueToUpdate, value) => {
    const temp = clone(userData);

    // update a top-level key
    if (typeof valueToUpdate === "string") {
      temp[valueToUpdate] = value;
    } else if (
      typeof valueToUpdate === "object" &&
      valueToUpdate.length === 2
    ) {
      temp[valueToUpdate[0]][valueToUpdate[1]] = value;
    } else if (
      typeof valueToUpdate === "object" &&
      valueToUpdate.length === 3
    ) {
      temp[valueToUpdate[0]][valueToUpdate[1]][valueToUpdate[2]] = value;
    }
    setUserData(temp);
  };

  const [userData, setUserData] = useLocalStorage("userData", initialState);

  const {
    accountLevel,
    accountPacks,
    seasonalPacks,
    seasonalAchievedLevel,
    seasonalBattlePasses,
    miscPacks,
    twitchPrime,
    purchasedPacks,
    seasonalQuestPacks,
    seasonalTreasurePacks,
    seasonalLTMs,
  } = userData;

  // DEPRECATED but still required due to a legacy version upgrade check
  const [questPacks] = useLocalStorage("questPacks", null);

  // identify returning users based on accountPacks value
  // 0 = display, 1 = form
  const startTab =
    accountPacks === null || parseInt(accountPacks) === 0 ? 1 : 0;

  // computed and ephemeral state
  const [activeTab, setActiveTab] = useState(startTab);
  const [totalPacks, setTotalPacks] = useState(0);

  const handleTabChange = (e, newValue) => {
    setActiveTab(newValue);

    let action = "Display Tab";
    if (newValue === 1) action = "Input Tab";
    if (newValue === 2) action = "More Info Tab";

    window.gtag("event", "click", {
      event_category: "Main Tab Navigation",
      event_action: action,
    });
  };

  const calcSeasonPacks = (seasonData, seasonLevel, purchasedBP) => {
    let packs = 0;

    // free packs
    seasonData.FREE.forEach((thisLevel) => {
      if (seasonLevel >= thisLevel) {
        packs++;
      }
    });

    // battle pass packs
    if (!!purchasedBP) {
      seasonData.PREMIUM.forEach((thisLevel) => {
        if (seasonLevel >= thisLevel) {
          packs++;
        }
      });
    }

    return packs;
  };

  const resetAll = () => {
    setUserData(initialState);
    setTotalPacks(0);
  };

  // account level
  useEffect(() => {
    let tempPacks = 0;

    // 2 - 20 = 1 pack / level
    if (accountLevel > 2) {
      if (accountLevel >= 20) tempPacks += 18;
      else tempPacks = accountLevel - 2;
    }

    // 21 - 300 = 0.5 packs / level
    if (accountLevel > 20) {
      if (accountLevel >= 300) tempPacks += 140;
      else tempPacks += Math.floor((accountLevel - 20) * 0.5);
    }

    // 301 - 500 = 0.2 packs / level
    if (accountLevel > 300) {
      if (accountLevel > 500) tempPacks += 40;
      else tempPacks += Math.floor((accountLevel - 300) * 0.2);
    }

    update("accountPacks", tempPacks);
  }, [accountLevel]); // eslint-disable-line react-hooks/exhaustive-deps

  // calculate all seasons
  useEffect(() => {
    BATTLEPASSES_ORDERED.forEach((thisBattlepass, i) => {
      // skip season 0 preseason
      if (i === 0) return;

      const tempPacks = calcSeasonPacks(
        thisBattlepass,
        seasonalAchievedLevel[i],
        seasonalBattlePasses[i]
      );

      // console.log(
      //   `processing season ${i}, found ${tempPacks} pack(s) based on a season level of ${seasonalAchievedLevel[i]}`
      // );

      update(["seasonalPacks", i], tempPacks);
    });
  }, [...seasonalAchievedLevel, ...seasonalBattlePasses]); // eslint-disable-line react-hooks/exhaustive-deps

  // calculate all seasonal quests
  useEffect(() => {
    BATTLEPASSES_ORDERED.forEach((thisBattlepass, i) => {
      // seasonal quests begin @ season 5
      if (i < 5) return;

      let tempPacks;
      const numTreasurePacks = parseInt(seasonalTreasurePacks[i]);

      // season 5
      if (i === 5) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks = tempPacks + 1;
        }
      }

      // season 6
      if (i === 6) {
        tempPacks = Math.floor(numTreasurePacks / 7);
        if (numTreasurePacks % 7 === 6) {
          tempPacks = tempPacks + 1;
        }
      }

      // season 7
      if (i === 7) {
        tempPacks = Math.floor(numTreasurePacks / 7);
        if (numTreasurePacks === 57) {
          tempPacks = 9;
        } else if (numTreasurePacks % 7 === 6) {
          tempPacks = tempPacks + 1;
        }
      }

      // season 8
      if (i === 8) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 60) {
          tempPacks++;
        }
      }

      // season 9
      if (i === 9) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 60) {
          tempPacks++;
        }
      }

      // season 10
      if (i === 10) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 60) {
          tempPacks++;
        }
      }

      // season 11
      if (i === 11) {
        tempPacks = Math.floor(numTreasurePacks / 5);

        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 45) {
          tempPacks++;
        }
      }

      // season 12
      if (i === 12) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 45) {
          tempPacks++;
        }
      }

      // FIXME: this is a copy of S12
      // season 13
      if (i === 13) {
        tempPacks = Math.floor(numTreasurePacks / 5);
        if (numTreasurePacks % 5 === 4) {
          tempPacks++;
        }
        if (numTreasurePacks === 45) {
          tempPacks++;
        }
      }

      // SEASON+

      update(["seasonalQuestPacks", i], tempPacks || null);
    });
  }, [...seasonalTreasurePacks]); // eslint-disable-line react-hooks/exhaustive-deps

  // total packs
  useEffect(
    () => {
      let total = 0;

      if (!!parseInt(accountPacks)) total += parseInt(accountPacks);
      if (!!twitchPrime) total += 5;

      // seasonal packs
      seasonalPacks.forEach((thisSeason) => {
        if (!!parseInt(thisSeason)) total += parseInt(thisSeason);
      });

      // seasonalQuestPacks
      seasonalQuestPacks.forEach((thisSeason) => {
        if (!!parseInt(thisSeason)) total += parseInt(thisSeason);
      });

      // seasonalLTMs
      seasonalLTMs.forEach((thisSeason) => {
        if (!!thisSeason) {
          thisSeason.forEach((thisLTM) => {
            if (!!parseInt(thisLTM)) total += parseInt(thisLTM);
          });
        }
      });

      if (!!parseInt(purchasedPacks)) total += parseInt(purchasedPacks);
      if (!!parseInt(miscPacks)) total += parseInt(miscPacks);

      setTotalPacks(total);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      accountPacks,
      twitchPrime,
      ...seasonalPacks, // eslint-disable-line react-hooks/exhaustive-deps
      ...seasonalQuestPacks, // eslint-disable-line react-hooks/exhaustive-deps
      ...seasonalLTMs, // eslint-disable-line react-hooks/exhaustive-deps
      purchasedPacks,
      miscPacks,
    ]
  );

  const adWidth = React.useCallback(() => {
    if (mqL) return 970;
    if (mqM) return 728;
    if (mqS) return 320;
    if (mqXS) return 300;
  }, [mqL, mqM, mqS, mqXS]);

  const adHeight = React.useCallback(() => {
    if (mqL || mqM) return 90;
    if (mqS || mqXS) return 50;
  }, [mqL, mqM, mqS, mqXS]);

  // 970 x 90 - L
  //    top: 459881192
  //    btm: 284755713
  // 728 x 90 - M
  //    top: 278087087
  //    btm: 281836754
  // 320 x 50 - S
  //    top: 590214965*
  //    btm: 596356815
  // 300 x 50 - XS
  //    top: 972548586
  //    btm: 608854942
  const adCodes = {
    lg: ["459881192", "284755713"],
    md: ["278087087", "281836754"],
    sm: ["590214965", "596356815"],
    xs: ["972548586", "608854942"],
  };
  const sizes = {
    lg: `970x90`,
    md: `728x90`,
    sm: `320x50`,
    xs: `300x50`,
  };

  useEffect(() => {
    let curSize = sizes.xs;
    let curCode = adCodes.xs;

    if (mqL) {
      curSize = sizes.lg;
      curCode = adCodes.lg;

      if (adsLoadedL) return;
    }
    if (mqM) {
      curSize = sizes.md;
      curCode = adCodes.md;

      if (adsLoadedM) return;
    }
    if (mqS) {
      curSize = sizes.sm;
      curCode = adCodes.sm;

      if (adsLoadedS) return;
    }
    if (mqXS) {
      curSize = sizes.xs;
      curCode = adCodes.xs;

      if (adsLoadedXS) return;
    }

    try {
      window._mNHandle.queue.push(function () {
        window._mNDetails.loadTag(curCode[0], curSize, curCode[0]);
      });
      window._mNHandle.queue.push(function () {
        window._mNDetails.loadTag(curCode[1], curSize, curCode[1]);
      });

      if (mqL) setAdsLoadedL(true);
      if (mqM) setAdsLoadedM(true);
      if (mqS) setAdsLoadedS(true);
      if (mqXS) setAdsLoadedXS(true);
    } catch (error) {
      console.error("_mNDetails method error:", error);
    }
  }, [
    mqL,
    mqM,
    mqS,
    mqXS,
    adCodes,
    sizes,
    adsLoadedL,
    adsLoadedM,
    adsLoadedS,
    adsLoadedXS,
  ]);

  // check for deprecated `questPacks` and show error if exists
  const [showQuestPacksWarning, setShowQuestPacksWarning] = useState(false);
  useEffect(() => {
    if (questPacks !== null) {
      setShowQuestPacksWarning(true);
      localStorage.removeItem("questPacks");
    }
  }, [questPacks]);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setShowQuestPacksWarning(false);
  };

  // unified state management upgrade check
  const [oldAccountLevel] = useLocalStorage("accountLevel", null);
  useEffect(() => {
    if (accountLevel === null && oldAccountLevel !== null) {
      console.log("Migration data found...");

      const migrationData = clone(initialState);

      const migrationItems = [
        "accountLevel",
        "accountPacks",
        "miscPacks",
        "purchasedPacks",
      ];

      migrationItems.forEach((item) => {
        migrationData[item] = parseInt(localStorage.getItem(item)) || null;
      });
      migrationData.twitchPrime =
        localStorage.getItem("twitchPrime") === "true" ? true : false;

      const seasonalAchievedLevel = [
        null,
        "s1Level",
        "s2Level",
        "s3Level",
        "s4Level",
        "s5Level",
        "s6Level",
        "s7Level",
        "s8Level",
        "s9Level",
        "s10Level",
        "s11Level",
        "s12Level",
      ];
      seasonalAchievedLevel.forEach((item, i) => {
        if (i === 0) return;
        migrationData.seasonalAchievedLevel[i] =
          parseInt(localStorage.getItem(item)) || null;
      });

      const seasonalBattlePasses = [
        null,
        "bp1",
        "bp2",
        "bp3",
        "bp4",
        "bp5",
        "bp6",
        "bp7",
        "bp8",
        "bp9",
        "bp10",
        "bp11",
        "bp12",
      ];
      seasonalBattlePasses.forEach((item, i) => {
        if (i === 0) return;
        migrationData.seasonalBattlePasses[i] =
          localStorage.getItem(item) === "true" ? true : false;
      });

      migrationData.seasonalLTMs[8][0] =
        parseInt(localStorage.getItem("season8LTM")) || null;
      migrationData.seasonalLTMs[9][0] =
        parseInt(localStorage.getItem("season9LTM")) || null;
      migrationData.seasonalLTMs[10][0] =
        parseInt(localStorage.getItem("arenasFlashEvents")) || null;
      migrationData.seasonalLTMs[10][1] =
        parseInt(localStorage.getItem("season10LTM")) || null;

      const seasonalPacks = [
        null,
        "season1Packs",
        "season2Packs",
        "season3Packs",
        "season4Packs",
        "season5Packs",
        "season6Packs",
        "season7Packs",
        "season8Packs",
        "season9Packs",
        "season10Packs",
        "season11Packs",
        "season12Packs",
      ];
      seasonalPacks.forEach((item, i) => {
        if (i === 0) return;
        migrationData.seasonalPacks[i] =
          parseInt(localStorage.getItem(item)) || null;
      });

      const seasonalQuestPacks = [
        null,
        null,
        null,
        null,
        null,
        "seasonalQuestPacks",
        "season6QuestPacks",
        "season7QuestPacks",
        "season8QuestPacks",
        "season9QuestPacks",
        "season10QuestPacks",
        "season11QuestPacks",
        "season12QuestPacks",
      ];
      seasonalQuestPacks.forEach((item, i) => {
        if (i < 5) return;
        migrationData.seasonalQuestPacks[i] =
          parseInt(localStorage.getItem(item)) || null;
      });

      const seasonalTreasurePacks = [
        null,
        null,
        null,
        null,
        null,
        "treasurePacks",
        "treasurePacksS6",
        "treasurePacksS7",
        "treasurePacksS8",
        "treasurePacksS9",
        "treasurePacksS10",
        "treasurePacksS11",
        "treasurePacksS12",
      ];
      seasonalTreasurePacks.forEach((item, i) => {
        if (i < 5) return;
        migrationData.seasonalTreasurePacks[i] =
          parseInt(localStorage.getItem(item)) || null;
      });

      setUserData(migrationData);
      localStorage.removeItem("accountLevel");

      console.log("Migration complete!");
    }
  }, [oldAccountLevel, accountLevel]); // eslint-disable-line react-hooks/exhaustive-deps

  // heirlooms
  const [showSnackbar, setShowSnackbar] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const closeSnackbar = (event, reason) => {
    if (reason === "clickaway") return;

    setShowSnackbar(null);
  };
  useEffect(() => {
    if (showSnackbar === null) return;

    setSnackbarMessage(showSnackbar);
  }, [showSnackbar, snackbarMessage]);

  return (
    <>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ position: "fixed", top: 48 }}
        open={showQuestPacksWarning}
        onClose={handleClose}
      >
        <Alert
          severity="warning"
          variant="filled"
          action={
            <>
              {" "}
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
              >
                <Close fontSize="small" />
              </IconButton>
            </>
          }
        >
          <Typography variant="body2">
            <strong>Heads Up!</strong> We now use Treasure Packs instead of Apex
            Packs for Seasonal Quests. Update your progress now!
          </Typography>
        </Alert>
      </Snackbar>

      {/* heirlooms */}
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{
          position: "fixed",
          top: 48,
        }}
        open={showSnackbar !== null}
        onClose={closeSnackbar}
        autoHideDuration={4000}
      >
        <Alert
          severity="success"
          variant="filled"
          style={{ backgroundColor: "#2e7d32" }}
          action={
            <>
              {" "}
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={closeSnackbar}
              >
                <Close fontSize="small" />
              </IconButton>
            </>
          }
        >
          <Typography variant="body2">{snackbarMessage}</Typography>
        </Alert>
      </Snackbar>

      <div
        style={{
          display: "block",
          position: "fixed",
          top: 64,
          left: 0,
          height: "100%",
          width: "100%",
        }}
      >
        {!!showConfetti && (
          <Confetti
            style={{
              position: "sticky",
              top: 0,
              left: 0,
            }}
            friction={0.96}
            numberOfPieces={1000}
            tweenDuration={10000}
            recycle={false}
            gravity={0.25}
            initialVelocityX={{ min: -7, max: 7 }}
            initialVelocityY={{ min: -20, max: 5 }}
            run={true}
            onConfettiComplete={() => {
              setShowConfetti(false);
            }}
            colors={[
              `${COLORS.HEIRLOOM}cc`,
              `${COLORS.HEIRLOOM}99`,
              `${COLORS.HEIRLOOM}66`,

              `${COLORS.RARE}99`,
              `${COLORS.RARE}66`,
              `${COLORS.HEIRLOOM}99`,
              `${COLORS.HEIRLOOM}66`,

              `${COLORS.EPIC}99`,
              `${COLORS.EPIC}66`,
              `${COLORS.HEIRLOOM}99`,
              `${COLORS.HEIRLOOM}66`,

              `${COLORS.LEGENDARY}99`,
              `${COLORS.LEGENDARY}66`,
              `${COLORS.HEIRLOOM}99`,
              `${COLORS.HEIRLOOM}66`,

              `${COLORS.HEIRLOOM}cc`,
              `${COLORS.HEIRLOOM}99`,
              `${COLORS.HEIRLOOM}66`,
            ]}
          />
        )}
      </div>

      {/* top ad */}
      <div style={{ textAlign: "center", marginBottom: "1.5rem" }}>
        <div
          style={{
            width: adWidth(),
            height: adHeight(),
            backgroundColor: "#333",
            margin: "auto",
            display: "block",
          }}
        >
          {!!mqL && <div id={adCodes.lg[0]} />}
          {!!mqM && <div id={adCodes.md[0]} />}
          {!!mqS && <div id={adCodes.sm[0]} />}
          {!!mqXS && <div id={adCodes.xs[0]} />}
        </div>
      </div>

      <div
        style={{
          maxWidth: 970,
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: "1.5rem",
        }}
      >
        <div
          style={{
            textAlign: "center",
            border: "1px solid #ccc",
            borderRadius: 4,
            marginLeft: 24,
            marginRight: 24,
            paddingTop: "0.75rem",
            paddingRight: "1rem",
            paddingBottom: "0.75rem",
            paddingLeft: "1rem",
            color: "#ccc",
            fontWeight: "bold",
            boxShadow: "0px 0px 6px red",
            fontSize: !mqBelow530 ? "1em" : "0.8em",
          }}
        >
          Looking for <u style={{ color: "#FFF" }}>Season 14: Hunted</u>? The{" "}
          <span style={{ color: "#FFF" }}>completely rebuilt version 2.0</span>{" "}
          is now available!&nbsp;
          <a
            href="https://gotahopuphere.com"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "red",
            }}
          >
            GotAHopUpHere.com
          </a>
        </div>
      </div>

      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        centered={true}
        variant="fullWidth"
        className="width-constrained"
        classes={{ root: classes.mainTabs }}
        style={{
          paddingLeft: !!mqBelow370 ? 0 : "1.5em",
          paddingRight: !!mqBelow370 ? 0 : "1.5em",
        }}
      >
        <Tab
          label="Progress"
          value={0}
          classes={{ root: classes.mainTab, selected: classes.tabActive }}
          data-cy="tab-progress"
        />
        <Tab
          label={`${!!mqBelow530 ? "" : "Your "}Activity`}
          value={1}
          classes={{ root: classes.mainTab, selected: classes.tabActive }}
          data-cy="tab-activity"
        />
        <Tab
          label="Heirlooms"
          value={3}
          classes={{ root: classes.mainTab, selected: classes.tabActive }}
          data-cy="tab-heirlooms"
        />
        <Tab
          label={`${!!mqBelow440 ? "" : "More "}Info`}
          value={2}
          classes={{ root: classes.mainTab, selected: classes.tabActive }}
          data-cy="tab-info"
        />
      </Tabs>
      <TabPanel value={activeTab} index={0}>
        <Display
          userData={userData}
          totalPacks={totalPacks}
          heirloomRecord={heirloomRecord}
        />
      </TabPanel>
      <TabPanel
        value={activeTab}
        index={1}
        className="userinfo-wrapper"
        style={{ overflowX: "hidden", overflowY: "scroll" }}
      >
        <UserInformation
          userData={userData}
          update={update}
          setActiveTab={setActiveTab}
          resetAll={resetAll}
        />
      </TabPanel>
      <TabPanel value={activeTab} index={3}>
        <Heirlooms
          totalPacks={totalPacks}
          heirloomRecord={heirloomRecord}
          setHeirloomRecord={setHeirloomRecord}
          setShowConfetti={setShowConfetti}
          setShowSnackbar={setShowSnackbar}
        />
      </TabPanel>
      <TabPanel value={activeTab} index={2}>
        <MoreInfo />
      </TabPanel>

      <div
        style={{
          textAlign: "center",
          marginTop: "1.5rem",
          marginBottom: "1rem",
        }}
      >
        <div
          style={{
            width: adWidth(),
            height: adHeight(),
            backgroundColor: "#333",
            margin: "auto",
            display: "block",
          }}
        >
          {!!mqL && <div id={adCodes.lg[1]} />}
          {!!mqM && <div id={adCodes.md[1]} />}
          {!!mqS && <div id={adCodes.sm[1]} />}
          {!!mqXS && <div id={adCodes.xs[1]} />}
        </div>
      </div>
    </>
  );
};
